import React from "react";
import ReportView from "../components/ReportView";
import { Tag } from "../components/UI";

const STATUS_TONE = { approved: "emerald", pending: "amber", rejected: "rose" };

function fmtDate(s) {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
  catch { return String(s).slice(0, 10); }
}

const columns = [
  { key: "erp_outlet_id", label: "ERP Outlet ID", filter: "text" },
  { key: "physio_name", label: "Physio", filter: "text" },
  { key: "shop_type", label: "ShopType", filter: "text", render: (r) => r.shop_type || "—" },
  { key: "clinic_name", label: "Clinic", filter: "text", render: (r) => r.clinic_name || "—" },
  { key: "shop_address", label: "ShopAddress", filter: "text", render: (r) => r.shop_address ? <span className="whitespace-normal max-w-[240px] inline-block leading-tight">{r.shop_address}</span> : "—" },
  { key: "delivery_address", label: "Delivery Address (WhatsApp)", filter: "text", render: (r) => r.delivery_address ? <span className="whitespace-normal max-w-[240px] inline-block leading-tight text-teal-800">{r.delivery_address}</span> : "—" },
  { key: "mobile", label: "Mobile", filter: "text" },
  { key: "city", label: "City", filter: "text", render: (r) => r.city || "—" },
  { key: "state", label: "State", filter: "text", render: (r) => r.state || "—" },
  { key: "beat", label: "Beat", filter: "text", render: (r) => r.beat || "—" },
  { key: "dse", label: "DSE", filter: "text", render: (r) => r.dse || "—" },
  { key: "onboarding_status", label: "Status", filter: "select", options: ["approved", "pending", "rejected"], render: (r) => <Tag tone={STATUS_TONE[r.onboarding_status] || "slate"}>{r.onboarding_status || "—"}</Tag> },
  { key: "registered_at", label: "Registered", render: (r) => fmtDate(r.registered_at), accessor: (r) => r.registered_at },
];

const monthOf = (s) => (s ? String(s).slice(0, 7) : null);

const charts = [
  { id: "reg-trend", type: "area", title: "Registrations over time", subtitle: "Monthly new registrations", valueLabel: "Registrations", groupBy: (r) => monthOf(r.registered_at), sort: "time", color: "#0A2540" },
  { id: "reg-top-cities", type: "bar", title: "Top cities", valueLabel: "Physios", groupBy: (r) => r.city, sort: "value_desc", limit: 10 },
  { id: "reg-by-state", type: "donut", title: "By state", valueLabel: "Physios", groupBy: (r) => r.state, limit: 8 },
];

export default function RegistrationReport() {
  return (
    <ReportView
      kicker="Field Assist · Outlet Master"
      title="Registration Report"
      subtitle="Physios newly registered (and refreshed) from the Field Assist outlet master. Tap Sync for a live pull. Filter by registration date range and mobile number."
      fetchPath="/reports/registrations"
      syncPath="/integrations/field-assist/outlets/sync"
      statusPath="/integrations/field-assist/outlets/status"
      columns={columns}
      charts={charts}
      searchableKeys={["erp_outlet_id", "physio_name", "clinic_name", "mobile", "city", "shop_address"]}
      exportFilename="registration-report"
      testId="registration-report"
      syncLabel="Sync registrations"
    />
  );
}
